import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateSubmissionBySubmitterData = { submission: '_formSubmission' };
var _bulkCreateSubmissionBySubmitterRequest = {
    submissions: '_formSubmission',
    submissionsV2: '_bulkCreateSubmissionBySubmitterData',
};
var _bulkCreateSubmissionBySubmitterResponse = {
    results: '_bulkSubmissionResult',
};
var _bulkDeleteSubmissionRequest = {};
var _bulkDeleteSubmissionResponse = {};
var _bulkMarkSubmissionsAsSeenRequest = {};
var _bulkMarkSubmissionsAsSeenResponse = {};
var _bulkRemoveSubmissionFromTrashBinRequest = {};
var _bulkRemoveSubmissionFromTrashBinResponse = {};
var _bulkSubmissionResult = { item: '_formSubmission' };
var _bulkUpdateFormSubmissionTagsByFilterRequest = {};
var _bulkUpdateFormSubmissionTagsByFilterResponse = {};
var _bulkUpdateFormSubmissionTagsRequest = {};
var _bulkUpdateFormSubmissionTagsResponse = {};
var _confirmSubmissionRequest = {};
var _confirmSubmissionResponse = { submission: '_formSubmission' };
var _countDeletedSubmissionsRequest = {};
var _countDeletedSubmissionsResponse = {};
var _countSubmissionsByFilterRequest = {};
var _countSubmissionsByFilterResponse = {};
var _countSubmissionsRequest = {};
var _countSubmissionsResponse = {};
var _createSubmissionBySubmitterRequest = { submission: '_formSubmission' };
var _createSubmissionBySubmitterResponse = { submission: '_formSubmission' };
var _createSubmissionRequest = { submission: '_formSubmission' };
var _createSubmissionResponse = { submission: '_formSubmission' };
var _deleteSubmissionRequest = {};
var _deleteSubmissionResponse = {};
var _formSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _getDeletedSubmissionRequest = {};
var _getDeletedSubmissionResponse = { submission: '_formSubmission' };
var _getFormattedSubmissionRequest = {};
var _getFormattedSubmissionResponse = {};
var _getMediaUploadURLRequest = {};
var _getMediaUploadURLResponse = {};
var _getSubmissionByCheckoutIdRequest = {};
var _getSubmissionByCheckoutIdResponse = { submission: '_formSubmission' };
var _getSubmissionDownloadUrlRequest = {};
var _getSubmissionDownloadUrlResponse = {};
var _getSubmissionRequest = {};
var _getSubmissionResponse = { submission: '_formSubmission' };
var _listDeletedSubmissionsRequest = {};
var _listDeletedSubmissionsResponse = { submissions: '_formSubmission' };
var _listFormattedSubmissionsRequest = {};
var _listFormattedSubmissionsResponse = {};
var _querySubmissionRequest = {};
var _querySubmissionResponse = { submissions: '_formSubmission' };
var _querySubmissionsByNamespaceForExportRequest = {};
var _querySubmissionsByNamespaceForExportResponse = {
    submissions: '_formSubmission',
};
var _querySubmissionsByNamespaceRequest = {};
var _querySubmissionsByNamespaceResponse = { submissions: '_formSubmission' };
var _removeSubmissionFromTrashBinRequest = {};
var _removeSubmissionFromTrashBinResponse = {};
var _restoreSubmissionFromTrashBinRequest = {};
var _restoreSubmissionFromTrashBinResponse = {
    submission: '_formSubmission',
};
var _searchSubmissionsByNamespaceForExportRequest = {};
var _searchSubmissionsByNamespaceForExportResponse = {
    submissions: '_formSubmission',
};
var _searchSubmissionsByNamespaceRequest = {};
var _searchSubmissionsByNamespaceResponse = {
    submissions: '_formSubmission',
};
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {};
var _updateSubmissionRequest = {
    mask: 'google.protobuf.FieldMask',
    submission: '_formSubmission',
};
var _updateSubmissionResponse = { submission: '_formSubmission' };
var _upsertContactFromSubmissionRequest = {};
var _upsertContactFromSubmissionResponse = {};
var _validateFormSubmissionRequest = { submission: '_formSubmission' };
var _validateFormSubmissionResponse = {};
function resolveWixFormsV4FormSubmissionServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/form-submission-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/form-submission-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixFormsV4FormSubmissionContactUpsertServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/form-submission-contact-mapping-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/form-submission-contact-mapping-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/form-submission-contact-mapping-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/form-submission-contact-mapping-service',
                destPath: '',
            },
            {
                srcPath: '/_api/form-submission-contact-mapping-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Upserts contact from submission. */
export function upsertContactFromSubmission(payload) {
    var _a = serializer(_upsertContactFromSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertContactFromSubmissionResponse, {}).fromJSON;
    function __upsertContactFromSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionContactUpsertService.UpsertContactFromSubmission',
            url: resolveWixFormsV4FormSubmissionContactUpsertServiceUrl({
                protoPath: '/v4/submissions-contacts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertContactFromSubmission.fromReq = fromReq;
    __upsertContactFromSubmission.__isAmbassador = true;
    return __upsertContactFromSubmission;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Creates a new submission.
 */
export function createSubmission(payload) {
    var _a = serializer(_createSubmissionRequest, { _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __createSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.CreateSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubmission.fromReq = fromReq;
    __createSubmission.__isAmbassador = true;
    return __createSubmission;
}
/**
 * Creates a new submission with specified submitter for a given form.
 * Internal, migration only.
 */
export function createSubmissionBySubmitter(payload) {
    var _a = serializer(_createSubmissionBySubmitterRequest, { _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSubmissionBySubmitterResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __createSubmissionBySubmitter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.CreateSubmissionBySubmitter',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/by-submitter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubmissionBySubmitter.fromReq = fromReq;
    __createSubmissionBySubmitter.__isAmbassador = true;
    return __createSubmissionBySubmitter;
}
/**
 * Creates multiple submissions with specified submitters.
 * Internal, migration only.
 */
export function bulkCreateSubmissionBySubmitter(payload) {
    var _a = serializer(_bulkCreateSubmissionBySubmitterRequest, { _bulkCreateSubmissionBySubmitterData: _bulkCreateSubmissionBySubmitterData, _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSubmissionBySubmitterResponse, { _bulkSubmissionResult: _bulkSubmissionResult, _formSubmission: _formSubmission }).fromJSON;
    function __bulkCreateSubmissionBySubmitter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkCreateSubmissionBySubmitter',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/bulk/submissions/by-submitter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSubmissionBySubmitter.fromReq = fromReq;
    __bulkCreateSubmissionBySubmitter.__isAmbassador = true;
    return __bulkCreateSubmissionBySubmitter;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Retrieves a submission by ID.
 */
export function getSubmission(payload) {
    var _a = serializer(_getSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __getSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubmission.fromReq = fromReq;
    __getSubmission.__isAmbassador = true;
    return __getSubmission;
}
/** Retrieves a submission by checkout ID. */
export function getSubmissionByCheckoutId(payload) {
    var _a = serializer(_getSubmissionByCheckoutIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubmissionByCheckoutIdResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __getSubmissionByCheckoutId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetSubmissionByCheckoutId',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/checkout/{checkoutId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubmissionByCheckoutId.fromReq = fromReq;
    __getSubmissionByCheckoutId.__isAmbassador = true;
    return __getSubmissionByCheckoutId;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Updates a submission. <br>
 * Each time the submission is updated, `revision` increments by 1. The existing `revision` must be included when updating the submission. This ensures you're working with the latest submission information, and prevents unintended overwrites.
 */
export function updateSubmission(payload) {
    var _a = serializer(_updateSubmissionRequest, { _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __updateSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'PATCH',
            methodFqn: 'wix.forms.v4.FormSubmissionService.UpdateSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submission.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubmission.fromReq = fromReq;
    __updateSubmission.__isAmbassador = true;
    return __updateSubmission;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Confirms a submission. <br>
 * You can only confirm a submission that has a `PENDING` status. When using forms from the [Wix Pricing Plans](https://www.wix.com/app-market/paid-plans?referral=collection&appIndex=42&referralTag=made-by-wix&referralSectionName=made-by-wix) app, the default submission status is `PENDING`. When using forms from the Wix Forms app, the default form submission status is `CONFIRMED`. You can change the default status for individual submissions using the [Update Submission](https://dev.wix.com/docs/rest/api-reference/wix-forms/form-submissions/update-submission) endpoint.
 */
export function confirmSubmission(payload) {
    var _a = serializer(_confirmSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __confirmSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.ConfirmSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmSubmission.fromReq = fromReq;
    __confirmSubmission.__isAmbassador = true;
    return __confirmSubmission;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Deletes a submission by ID.
 */
export function deleteSubmission(payload) {
    var _a = serializer(_deleteSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSubmissionResponse, {}).fromJSON;
    function __deleteSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSubmissionService.DeleteSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSubmission.fromReq = fromReq;
    __deleteSubmission.__isAmbassador = true;
    return __deleteSubmission;
}
/** Deletes submissions by IDS for specific form. */
export function bulkDeleteSubmission(payload) {
    var _a = serializer(_bulkDeleteSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteSubmissionResponse, {}).fromJSON;
    function __bulkDeleteSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkDeleteSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/bulk/submissions/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteSubmission.fromReq = fromReq;
    __bulkDeleteSubmission.__isAmbassador = true;
    return __bulkDeleteSubmission;
}
/** Restores deleted submission */
export function restoreSubmissionFromTrashBin(payload) {
    var _a = serializer(_restoreSubmissionFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreSubmissionFromTrashBinResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __restoreSubmissionFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.RestoreSubmissionFromTrashBin',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin/{submissionId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreSubmissionFromTrashBin.fromReq = fromReq;
    __restoreSubmissionFromTrashBin.__isAmbassador = true;
    return __restoreSubmissionFromTrashBin;
}
/** Remove deleted submission */
export function removeSubmissionFromTrashBin(payload) {
    var _a = serializer(_removeSubmissionFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeSubmissionFromTrashBinResponse, {}).fromJSON;
    function __removeSubmissionFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'DELETE',
            methodFqn: 'wix.forms.v4.FormSubmissionService.RemoveSubmissionFromTrashBin',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeSubmissionFromTrashBin.fromReq = fromReq;
    __removeSubmissionFromTrashBin.__isAmbassador = true;
    return __removeSubmissionFromTrashBin;
}
/** Remove multiple deleted submissions */
export function bulkRemoveSubmissionFromTrashBin(payload) {
    var _a = serializer(_bulkRemoveSubmissionFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRemoveSubmissionFromTrashBinResponse, {}).fromJSON;
    function __bulkRemoveSubmissionFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkRemoveSubmissionFromTrashBin',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRemoveSubmissionFromTrashBin.fromReq = fromReq;
    __bulkRemoveSubmissionFromTrashBin.__isAmbassador = true;
    return __bulkRemoveSubmissionFromTrashBin;
}
/** List deleted submissions */
export function listDeletedSubmissions(payload) {
    var _a = serializer(_listDeletedSubmissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedSubmissionsResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __listDeletedSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.ListDeletedSubmissions',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedSubmissions.fromReq = fromReq;
    __listDeletedSubmissions.__isAmbassador = true;
    return __listDeletedSubmissions;
}
/** Get deleted submission */
export function getDeletedSubmission(payload) {
    var _a = serializer(_getDeletedSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedSubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __getDeletedSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetDeletedSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedSubmission.fromReq = fromReq;
    __getDeletedSubmission.__isAmbassador = true;
    return __getDeletedSubmission;
}
/**
 * Deprecated on '2023-08-08'. Use QuerySubmissionsByNamespace.
 * @deprecated It has been replaced with com.wixpress.forms.v4.FormSubmissionService.QuerySubmissionsByNamespace(), and will be removed on 2025-04-01.
 */
export function querySubmission(payload) {
    var _a = serializer(_querySubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySubmissionResponse, {
        _formSubmission: _formSubmission,
    }).fromJSON;
    function __querySubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.QuerySubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySubmission.fromReq = fromReq;
    __querySubmission.__isAmbassador = true;
    return __querySubmission;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 *
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/forms/form-submissions/filter-and-sort).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function searchSubmissionsByNamespace(payload) {
    var _a = serializer(_searchSubmissionsByNamespaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchSubmissionsByNamespaceResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __searchSubmissionsByNamespace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.SearchSubmissionsByNamespace',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/namespace/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchSubmissionsByNamespace.fromReq = fromReq;
    __searchSubmissionsByNamespace.__isAmbassador = true;
    return __searchSubmissionsByNamespace;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 *
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/forms/form-submissions/filter-and-sort).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function searchSubmissionsByNamespaceForExport(payload) {
    var _a = serializer(_searchSubmissionsByNamespaceForExportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchSubmissionsByNamespaceForExportResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __searchSubmissionsByNamespaceForExport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.SearchSubmissionsByNamespaceForExport',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/namespace/search/export',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchSubmissionsByNamespaceForExport.fromReq = fromReq;
    __searchSubmissionsByNamespaceForExport.__isAmbassador = true;
    return __searchSubmissionsByNamespaceForExport;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 *
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/forms/form-submissions/filter-and-sort).
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function querySubmissionsByNamespace(payload) {
    var _a = serializer(_querySubmissionsByNamespaceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySubmissionsByNamespaceResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __querySubmissionsByNamespace(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.QuerySubmissionsByNamespace',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/namespace/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySubmissionsByNamespace.fromReq = fromReq;
    __querySubmissionsByNamespace.__isAmbassador = true;
    return __querySubmissionsByNamespace;
}
/**
 * Returns a list of up to 100 submissions, given the provided paging, filtering, and sorting.
 *
 * You can only query submissions for export from a specified namespace. Use the query filter on the `namespace` field, otherwise you will receive an error.
 *
 * For field support for filters and sorting, see [Form Submissions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/forms/form-submissions/filter-and-sort).option
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language), [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination), and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function querySubmissionsByNamespaceForExport(payload) {
    var _a = serializer(_querySubmissionsByNamespaceForExportRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySubmissionsByNamespaceForExportResponse, { _formSubmission: _formSubmission }).fromJSON;
    function __querySubmissionsByNamespaceForExport(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.QuerySubmissionsByNamespaceForExport',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/namespace/query/export',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySubmissionsByNamespaceForExport.fromReq = fromReq;
    __querySubmissionsByNamespaceForExport.__isAmbassador = true;
    return __querySubmissionsByNamespaceForExport;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Counts the number of submissions belonging to forms that were filtered and contain a provided expression.
 */
export function countSubmissionsByFilter(payload) {
    var _a = serializer(_countSubmissionsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countSubmissionsByFilterResponse, {}).fromJSON;
    function __countSubmissionsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.CountSubmissionsByFilter',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/count-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countSubmissionsByFilter.fromReq = fromReq;
    __countSubmissionsByFilter.__isAmbassador = true;
    return __countSubmissionsByFilter;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Counts the number of submissions belonging to the specified forms.
 */
export function countSubmissions(payload) {
    var _a = serializer(_countSubmissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countSubmissionsResponse, {}).fromJSON;
    function __countSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.CountSubmissions',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countSubmissions.fromReq = fromReq;
    __countSubmissions.__isAmbassador = true;
    return __countSubmissions;
}
/** Counts the number of deleted submissions belonging to the specified forms. */
export function countDeletedSubmissions(payload) {
    var _a = serializer(_countDeletedSubmissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countDeletedSubmissionsResponse, {}).fromJSON;
    function __countDeletedSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.CountDeletedSubmissions',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/trash-bin/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countDeletedSubmissions.fromReq = fromReq;
    __countDeletedSubmissions.__isAmbassador = true;
    return __countDeletedSubmissions;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Retrieves a URL, generated by [Media Manager](https://dev.wix.com/api/rest/media/media-manager/files/generate-file-upload-url), to allow clients to upload a file to a form for submission.
 */
export function getMediaUploadUrl(payload) {
    var _a = serializer(_getMediaUploadURLRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMediaUploadURLResponse, {}).fromJSON;
    function __getMediaUploadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetMediaUploadURL',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/media-upload-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMediaUploadUrl.fromReq = fromReq;
    __getMediaUploadUrl.__isAmbassador = true;
    return __getMediaUploadUrl;
}
/**
 * > **Note:** The Form Submission API only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Marks form submissions as "seen". <br>
 * This endpoint marks the submissions as if they were seen by the site owner. Only site collaborators with the [Manage Submission](https://support.wix.com/en/article/roles-permissions-accessing-roles-permissions) permissions can mark submissions.
 */
export function bulkMarkSubmissionsAsSeen(payload) {
    var _a = serializer(_bulkMarkSubmissionsAsSeenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMarkSubmissionsAsSeenResponse, {}).fromJSON;
    function __bulkMarkSubmissionsAsSeen(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkMarkSubmissionsAsSeen',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/bulk/submissions/mark-as-seen',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMarkSubmissionsAsSeen.fromReq = fromReq;
    __bulkMarkSubmissionsAsSeen.__isAmbassador = true;
    return __bulkMarkSubmissionsAsSeen;
}
/** Gets submission as document which may include the document download url if the document is ready. */
export function getSubmissionDownloadUrl(payload) {
    var _a = serializer(_getSubmissionDownloadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubmissionDownloadUrlResponse, {}).fromJSON;
    function __getSubmissionDownloadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetSubmissionDownloadUrl',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}/document',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubmissionDownloadUrl.fromReq = fromReq;
    __getSubmissionDownloadUrl.__isAmbassador = true;
    return __getSubmissionDownloadUrl;
}
/** Retrieves a submission formatted by language */
export function getFormattedSubmission(payload) {
    var _a = serializer(_getFormattedSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormattedSubmissionResponse, {}).fromJSON;
    function __getFormattedSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.GetFormattedSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{submissionId}/formatted',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFormattedSubmission.fromReq = fromReq;
    __getFormattedSubmission.__isAmbassador = true;
    return __getFormattedSubmission;
}
/** Retrieves a list of submissions formatted by language */
export function listFormattedSubmissions(payload) {
    var _a = serializer(_listFormattedSubmissionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFormattedSubmissionsResponse, {}).fromJSON;
    function __listFormattedSubmissions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'GET',
            methodFqn: 'wix.forms.v4.FormSubmissionService.ListFormattedSubmissions',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/formatted',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFormattedSubmissions.fromReq = fromReq;
    __listFormattedSubmissions.__isAmbassador = true;
    return __listFormattedSubmissions;
}
/** Update Extended Fields of the Form */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {}).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.UpdateExtendedFields',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/{id}/extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/** Bulk update tags on form submissions. */
export function bulkUpdateFormSubmissionTags(payload) {
    var _a = serializer(_bulkUpdateFormSubmissionTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFormSubmissionTagsResponse, {}).fromJSON;
    function __bulkUpdateFormSubmissionTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkUpdateFormSubmissionTags',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/bulk/submissions/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFormSubmissionTags.fromReq = fromReq;
    __bulkUpdateFormSubmissionTags.__isAmbassador = true;
    return __bulkUpdateFormSubmissionTags;
}
/** Bulk update tags on form submissions by filter. */
export function bulkUpdateFormSubmissionTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateFormSubmissionTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFormSubmissionTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateFormSubmissionTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.BulkUpdateFormSubmissionTagsByFilter',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/bulk/submissions/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFormSubmissionTagsByFilter.fromReq = fromReq;
    __bulkUpdateFormSubmissionTagsByFilter.__isAmbassador = true;
    return __bulkUpdateFormSubmissionTagsByFilter;
}
/** Called to validate submission before creation. */
export function validateFormSubmission(payload) {
    var _a = serializer(_validateFormSubmissionRequest, { _formSubmission: _formSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateFormSubmissionResponse, {}).fromJSON;
    function __validateFormSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.forms.v4.submission',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionService.ValidateFormSubmission',
            url: resolveWixFormsV4FormSubmissionServiceUrl({
                protoPath: '/v4/submissions/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateFormSubmission.fromReq = fromReq;
    __validateFormSubmission.__isAmbassador = true;
    return __validateFormSubmission;
}
//# sourceMappingURL=http.impl.js.map